import React from 'react';
import classNames from 'classnames';

import { Icon } from '../Icon/Icon';

interface Props {
  id: string;
  value: string;
  label?: string;
  onChange: (value: string) => void;
  className?: string;
  error?: string | boolean;
  isChecked: boolean;
  labelClassName?: string;
  renderLabel?: () => JSX.Element;
  renderAfterLabel?: () => JSX.Element;
  isRecommended?: boolean; // Adding a recommended flag to the top right of the checkbox option - used in PickAPlan step
}

export const CheckboxInput = (props: Props) => {
  const {
    id,
    label,
    onChange,
    className,
    error,
    value,
    isChecked,
    renderLabel,
    renderAfterLabel,
  } = props;

  return (
    <div
      className={classNames('CheckboxInput', className, { hasError: !!error })}
    >
      <label htmlFor={id} className="CheckboxInput-group">
        <input
          className="CheckboxInput-input"
          name={id}
          id={id}
          type="checkbox"
          value={value}
          checked={isChecked}
          onChange={() => {
            onChange(value);
          }}
        />

        <span className="Checkbox-check" />

        <div className="CheckboxInput-labels">
          {!renderLabel && (
            <span className="CheckboxInput-label">{label}</span>
          )}
          {renderLabel && renderLabel()}
        </div>
      </label>

      {/* Error message */}
      {error && (
        <div className="CheckboxInput-error">
          <Icon name="ic-exclamation" />
          <span>{error}</span>
        </div>
      )}

      {renderAfterLabel && renderAfterLabel()}
    </div>
  );
};
